import { render, staticRenderFns } from "./QZ04.vue?vue&type=template&id=615a25f2&scoped=true"
import script from "./QZ04.vue?vue&type=script&lang=js"
export * from "./QZ04.vue?vue&type=script&lang=js"
import style0 from "./QZ04.vue?vue&type=style&index=0&id=615a25f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615a25f2",
  null
  
)

export default component.exports